const comments = [
  {
    name: '影迷小王',
    text: '之前一直在纠结97视频和丝瓜视频选哪个，看了榴莲视频的对比之后思路清晰多了，已经确定了适合自己的平台。',
    date: '2026-07-28',
  },
  {
    name: '资深观察者',
    text: '蓝莓视频的独家内容确实有吸引力，但丝瓜视频的界面体验更好一些。榴莲视频的对比分析帮我省了很多试错时间。',
    date: '2026-07-26',
  },
  {
    name: '新手小白',
    text: '作为刚接触在线视频平台的新人，榴莲视频的导航和指南非常友好。91在线视频和糖心视频的介绍让我有了初步了解。',
    date: '2026-07-24',
  },
  {
    name: '平台猎人',
    text: '几乎所有热门平台都体验过了，榴莲视频的总结很到位。黑桃视频最近的功能更新确实值得关注，推荐试试。',
    date: '2026-07-21',
  },
  {
    name: '理性选择者',
    text: '有用的导航站！不偏不倚的介绍风格让人放心。希望后续能加入更多新兴平台的信息，持续关注中。',
    date: '2026-07-19',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4 whitespace-nowrap">
            读者评论
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            读者反馈
          </h2>
          <p className="mt-3 text-foreground-600 text-sm max-w-xl mx-auto">
            来自真实用户的使用体验与建议
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 max-w-5xl mx-auto">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl border border-background-200/60 p-5"
            >
              <div className="flex items-center gap-2 mb-3">
                <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-xs font-bold text-accent-700">
                    {comment.name[0]}
                  </span>
                </div>
                <div>
                  <p className="text-xs font-semibold text-foreground-900 whitespace-nowrap">
                    {comment.name}
                  </p>
                  <p className="text-[10px] text-foreground-400">{comment.date}</p>
                </div>
              </div>
              <p className="text-xs text-foreground-600 leading-relaxed">
                {comment.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}